import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(
    private http: HttpClient,
    private envService : EnvService
  ) { }

  changePassword(postData: any) {
    return this.http.post(this.envService.baseUrl,+ 'change-password', postData);
  }

}
